import {useState} from "react";
import api from "../../../../utils/api";
import {setBottomBarError, setBottomBarSucces} from "../../../../utils/Functions";
import {useAppContext} from "../../../../context/Context";
import {ACTION} from "../../../../context/actionTypes";

export default function useModifyScalewayKeyModal() {
    const [, dispatch] = useAppContext();
    const [openaiAPIKey, setOpenaiAPIKey] = useState("");
    const [errors, setErrors] = useState("");

    const toggleMe = () => dispatch({ type: ACTION.SET_GENERIC_MODAL, payload: null });

    const handleInputChange = (event) => {
        const {value} = event.target;
        setOpenaiAPIKey(value);
    };

    async function handleKeySave(e) {
        try {
            e.preventDefault();
            let curErrors = null;
            if (!openaiAPIKey) curErrors = "La clé d'API est obligatoire";

            setErrors(curErrors);

            if (curErrors != null) return;
            await api.patch("/configuration/", {
                openai_api_key: openaiAPIKey,
            });
            setBottomBarSucces(dispatch, "La clé d'API a été modifiée.");
            toggleMe();
        } catch (e) {
            setBottomBarError(dispatch, e);
        }
    }

    return [
        {apiKey: openaiAPIKey, errors},
        {handleInputChange, handleKeySave, toggleMe},
    ]
}